<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ dispatch_reason.id ? $t('dispatchReason.form.editTitle') : $t('dispatchReason.form.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('dispatchReason.form.nameLabel') }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="dispatch_reason.name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name"
                        ><span class="required">*</span> {{ $t('dispatchReason.form.dispatchTypeLabel') }}
                      </label>
                      <v-select
                        :options="dispatch_types"
                        :reduce="(dispatch_types) => dispatch_types.id"
                        :label="'name'"
                        v-model="dispatch_reason.dispatch_type_id"
                        class="vselect"
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name"
                        ><span class="required">*</span> {{ $t('dispatchReason.form.companyLabel') }}
                      </label>
                      <v-select
                        :options="companies"
                        :reduce="(companies) => companies.id"
                        :label="'name'"
                        v-model="dispatch_reason.tenancy_id"
                        class="vselect"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="inputUser">
                        <span class="required">*</span> {{ $t('common.status') }}:
                      </label>
                      <select
                        v-model="dispatch_reason.status"
                        class="form-control"
                      >
                        <option :value="1">{{ $t('common.active') }}</option>
                        <option :value="0">{{ $t('common.inactive') }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('dispatchReason.form.descriptionLabel') }}
                      </label>
                      <textarea
                        class="form-control"
                        cols="30"
                        rows="3"
                        v-model="dispatch_reason.description"
                      ></textarea>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t('dispatchReason.form.requiredFields') }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link
                      to="/dispatch_reasons"
                      class="btn btn-back mr-1"
                    >
                      <i class="fa fa-arrow-left"></i> {{ $t('common.back') }}
                    </router-link>
                    <a v-if="$hasAbility('node.admin')" class="btn btn-add" @click="save">
                      {{ $t('common.save') }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      dispatch_reason: {
        name: "",
        description: "",
        tenancy_id: "",
        dispatch_type_id: "",
        status: "1",
      },
      companies: [],
      dispatch_types: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "dispatch_reasons";

      if (self.dispatch_reason.id) {
        self.dispatch_reason._method = "PUT";
        api += "/" + self.dispatch_reason.id;
      }

      self.$loading(true);

      axios
        .post(api, self.dispatch_reason)
        .then((response) => {
          self.$message(
            self.$t('dispatchReason.messages.successTitle'),
            self.$t('dispatchReason.messages.saveSuccess'),
            "success"
          );
          self.$loading(false);
          this.$router.push("/dispatch_reasons");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function () {
      const self = this;
      let api = self.$store.state.api + "companies?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDispatchTypes: function () {
      const self = this;
      let api =
        self.$store.state.api + "dispatch_types?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.dispatch_types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDispatchReason: function (id) {
      const self = this;
      const api = self.$store.state.api + "dispatch_reasons/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.dispatch_reason = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getCompanies();
    self.getDispatchTypes();

    let id = self.$route.params.id;
    if (id) {
      self.getDispatchReason(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>